import { Modal } from "react-bootstrap";
import { getCurrentLangFromRedux, getDir } from "../../algorithms/styleChanges";
import { styleEnd } from "../../algorithms/styleDirection";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
const ModalComponent = ({
  size,
  title,
  footer,
  body,
  modalVisible,
  setModalVisible,
  titleIconName,
  titleIconPrefix,
  titleIconColor,
  titleIconSize,
  hasIcon,
  svgIcon,
  fullscreen,
  centered,
  background,
  hasImage,
}) => {
  return (
    <Modal
      show={modalVisible}
      size={size ?? "xl"}
      aria-labelledby="contained-modal-title-vcenter"
      centered={centered ?? true}
      backdrop={"static"}
      fullscreen={fullscreen}
      contentClassName={background ?? ""}
    >
      <Modal.Header style={{ direction: getDir(getCurrentLangFromRedux()) }}>
        <Modal.Title id="contained-modal-title-vcenter">
          <div className="d-flex align-items-center mx-md-3 mx-1">
            <div
              className="mx-2 d-flex justify-content-center align-items-center"
              style={{
                height: 32,
                width: 32,
              }}
            >
              {hasIcon ? (
                <Icon
                  iconPrefix={titleIconPrefix ?? "far"}
                  name={titleIconName ?? "folder-open"}
                  color={titleIconColor ?? "rgb(12, 87, 76)"}
                  size={titleIconSize}
                />
              ) : null}

              {svgIcon ? svgIcon : null}
              {hasImage ? hasImage : null}
            </div>
            <div className="text-dark d-flex align-content-center">
              <p
                className="my-0 "
                style={{
                  fontSize: 18,
                  textAlign: "justify",
                  color: "rgb(12, 87, 76)",
                }}
              >
                {title ?? "Modal Tilte"}
              </p>
            </div>
          </div>
        </Modal.Title>
        <div className={`d-flex justify-content-end mt-2 ${styleEnd("m", 3)}`}>
          <Icon
            name="times"
            size={22}
            color={"rgb(12, 87, 76)"}
            onclick={() => {
              setModalVisible(false);
            }}
          />
        </div>
      </Modal.Header>
      <Modal.Body style={{ direction: getDir(getCurrentLangFromRedux()) }}>
        {body}
      </Modal.Body>
      {footer ? <Modal.Footer>{footer}</Modal.Footer> : null}
    </Modal>
  );
};

export default ModalComponent;
